//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import fileUploader from '../../views/common-components/file-uploader';

export default {
  name: 'deliveryPlanEdit',
  components: {
    fileUploader
  },
  data() {
    return {
      loading: false,
      saving: false,
      deliveryPlan: {
        id: 0,
        image: {
          associateType: 'DeliveryPlanFile',
          associateId: 0
        }
      },
      rules: {
        name: [{required: true, message: '请输入计划名称', trigger: 'blur'}],
        cityId: [{required: true, type: 'number', message: '请选择城市', trigger: 'change'}],
        projectId: [{required: true, type: 'number', message: '请选择项目', trigger: 'change'}],
        projectStages: [{required: true, message: '请选择分期', trigger: 'change'}],
        roomStructureName: [{required: true, message: '请选择楼栋', trigger: 'change'}]
      },
      title: '',
      projects: [],
      cityList: [],
      stages: [],
      loudongs: [],
      projectStages: '',
      selectProjectId: 0,
      showDeliveryPlanModal: false,
      deliveryDate: [],
      time: [],
      afternoonTime: [],
      roomStructureName: [],
      showTreeModal: false,
      data1: [],
      dranges: []
    };
  },
  methods: {
    getDeliveryPlanById() {
      this.loading = true;
      abp.ajax.get('/api/services/app/Delivery/GetDeliveryPlanById?id=' + this.planId).then(res => {
        // this.deliveryPlan = {};
        // this.$refs.deliveryPlanForm.resetFields();
        this.$refs.deliveryPlanForm.resetFields();
        this.deliveryPlan = JSON.parse(JSON.stringify(res.data.result));
        if (!this.deliveryPlan.image) {
          this.deliveryPlan.image = {
            associateType: 'DeliveryPlanFile',
            associateId: this.deliveryPlan.id
          }
        }
        this.deliveryDate = [];
        this.time = [];
        this.afternoonTime = [];
        this.roomStructureName = [];
        if (this.deliveryPlan.id > 0) {
          this.title = '编辑计划';
          var select = this.cityList.filter(x => x.id === parseInt(this.deliveryPlan.cityId));
          this.projects = select[0].projects;
          // this.projectStages = this.deliveryPlan.projectStages;
          this.selectProjectId = this.deliveryPlan.projectId;

          this.deliveryDate.push(this.deliveryPlan.deliveryStartTimeStr);
          this.deliveryDate.push(this.deliveryPlan.deliveryEndTimeStr);
          if (this.deliveryPlan.startTime == null) {
            this.deliveryPlan.startTime = '';
          }
          if (this.deliveryPlan.endTime == null) {
            this.deliveryPlan.endTime = '';
          }
          this.time.push(this.deliveryPlan.startTime);
          this.time.push(this.deliveryPlan.endTime);
          if (this.deliveryPlan.afternoonStartTime && this.deliveryPlan.afternoonStartTime) {
            this.afternoonTime.push(this.deliveryPlan.afternoonStartTime);
            this.afternoonTime.push(this.deliveryPlan.afternoonEndTime);
          }
          // if (this.deliveryPlan.roomStructureName.length > 0) {
          //     this.roomStructureName = this.deliveryPlan.roomStructureName.split(',');
          // }
          console.log(this.deliveryPlan.deliveryRang);
          this.dranges = [];
          this.dranges = JSON.parse(this.deliveryPlan.deliveryRange);

          this.deliveryPlan.steps = this.deliveryPlan.steps.map(z => z.step);

        } else {
          this.title = '新增计划';
        }

      }).finally(() => {
        this.loading = false;
      });
    },
    onSave() {
      console.log(this.deliveryPlan);
      // return;
      // this.deliveryPlan.roomStructureName = this.roomStructureName.toString();
      if (!this.dranges.length > 0) {
        abp.message.warn('请选择交付范围');
        return;
      }
      // if (!this.deliveryPlan.deliveryStartTime) {
      //     abp.message.warn('请选择交付日期');
      //     return;
      // }
      //
      // if (!this.deliveryPlan.deliveryEndTime) {
      //     abp.message.warn('请选择交付日期');
      //     return;
      // }
      //
      // if (!this.deliveryPlan.startTime) {
      //     abp.message.warn('请选择交付时段');
      //     return;
      // }
      //
      // if (!this.deliveryPlan.endTime) {
      //     abp.message.warn('请选择交付时段');
      //     return;
      // }
      // if (!this.deliveryPlan.appointmentStartTime) {
      //     abp.message.warn('请选择开发预约开始时间');
      //     return;
      // }
      // if (!this.deliveryPlan.appointmentEndTime) {
      //     abp.message.warn('请选择开发预约结束时间');
      //     return;
      // }

      this.deliveryPlan.deliveryRange = JSON.stringify(this.dranges);
      this.$refs.deliveryPlanForm.validate(async (val) => {
        if (val) {
          this.saving = true;
          abp.ajax.post('/api/services/app/Delivery/SaveDeliveryPlan', this.deliveryPlan).then(res => {
            // this.showDeliveryPlanEditModal = false;
            // this.getPage();
            this.$router.push({
              name: 'deliveryPlanInfo',
              params: {
                planId: res.data.result
              }
            });
          }).finally(() => {
            this.saving = false;
          });
        }
      });
    },
    getCities() {
      this.$store.dispatch({
        type: 'city/getCityList'
      }).then(() => {
        this.cityList = this.$store.state.city.cityList;
        if (this.planId > 0) {
          this.getDeliveryPlanById();
        }
      });
    },
    cityOnChange(data) {
      var vm = this;
      vm.deliveryPlan.projectId = 0;
      vm.deliveryPlan.projectName = '';
      this.projects = [];
      vm.stages = [];
      // vm.$refs.stageSelectRef.clearSingleSelect();

      if (data) {
        vm.deliveryPlan.cityId = data.value;
        vm.deliveryPlan.cityName = data.label;
        vm.deliveryPlan.cityName = vm.deliveryPlan.cityName.replace(/\ +/g, '');
        vm.deliveryPlan.cityName = vm.deliveryPlan.cityName.replace(/[\r\n]/g, '');
        var select = this.cityList.filter(x => x.id === parseInt(this.deliveryPlan.cityId));
        this.projects = select[0].projects;
        // vm.getProjects(this.workOrder.cityId);
      }
    },
    onProjectChange(data) {
      const vm = this;
      // vm.deliveryPlan.roomId = 0;
      // vm.deliveryPlan.roomNum = '';
      vm.stages = [];
      // vm.$refs.stageSelectRef.clearSingleSelect();
      if (data) {
        vm.deliveryPlan.projectId = data.value;
        vm.deliveryPlan.projectName = data.label;
        vm.deliveryPlan.projectName = vm.deliveryPlan.projectName.replace(/\ +/g, '');
        vm.deliveryPlan.projectName = vm.deliveryPlan.projectName.replace(/[\r\n]/g, '');
        vm.getProjectStages(vm.deliveryPlan.projectId);
        this.selectProjectId = vm.deliveryPlan.projectId;
      } else {
        vm.deliveryPlan.projectId = 0;
        vm.deliveryPlan.projectName = '';
      }
    },
    onStageChange(data) {
      console.log(data);
      var vm = this;
      vm.loudongs = [];
      vm.$refs.loudongsRef.clearSingleSelect();
      if (data) {
        this.deliveryPlan.projectStages = data.label;
        vm.deliveryPlan.projectStages = vm.deliveryPlan.projectStages.replace(/\ +/g, '');
        vm.deliveryPlan.projectStages = vm.deliveryPlan.projectStages.replace(/[\r\n]/g, '');
        this.getLoudong(this.selectProjectId, vm.deliveryPlan.projectStages);
      }
    },
    onStageClear() {
      var vm = this;
      vm.loudongs = [];
      vm.$refs.loudongsRef.clearSingleSelect();
    },
    deliveryStartTimeChange(date) {
      this.deliveryPlan.deliveryStartTime = date;
    },
    deliveryEndTimeChange(date) {
      this.deliveryPlan.deliveryEndTime = date;
    },
    appointmentStartTimeChange(date) {
      this.deliveryPlan.appointmentStartTime = date;
      // this.deliveryPlan.appointmentStartTimeStr = date;
    },
    appointmentEndTimeChange(date) {
      this.deliveryPlan.appointmentEndTime = date;
      // this.deliveryPlan.appointmentEndTimeStr = date;
    },
    getProjectStages(projectId) {
      abp.ajax.get('/api/services/app/Project/GetProjectStages?projectId=' + projectId).then(res => {
        this.stages = [];
        this.stages.push(...res.data.result.items);
      });
    },
    getLoudong(projectId, fenqiName) {
      abp.ajax.get('/api/services/app/Project/GetLouDong?projectId=' + projectId + '&fenqiName=' + fenqiName).then(res => {
        this.loudongs = [];
        this.loudongs.push(...res.data.result);
      });
    },
    deliveryDateChange(date) {
      console.log(date);
      this.deliveryPlan.deliveryStartTime = date[0];
      this.deliveryPlan.deliveryEndTime = date[1];
    },
    timeChange(time) {
      // console.log(time);
      this.deliveryPlan.startTime = time[0];
      this.deliveryPlan.endTime = time[1];
    },
    afternoonTimeChange(time) {
      this.deliveryPlan.afternoonStartTime = time[0];
      this.deliveryPlan.afternoonEndTime = time[1];
    },
    showTree() {
      if (this.deliveryPlan.projectId > 0) {
        this.getStagingBuildings(this.deliveryPlan.projectId);
      } else {
        abp.message.warn('请选择项目');
      }

    },
    onTreeSelect() {
      console.log(this.$refs.deliveryPlanRef.getCheckedNodes());
      var list = this.$refs.deliveryPlanRef.getCheckedNodes();
      var s1 = list.filter(x => x.type != 'ProjectStages');
      console.log(s1);
      this.dranges = [];
      for (var i = 0; i < s1.length; i++) {
        var s = s1[i].projectStages + '-' + s1[i].key;
        this.dranges.push(s);
      }
      console.log(this.dranges);
      this.showTreeModal = false;
    },
    delDeliveryPlan(row) {
      const vm = this;
      this.$Modal.confirm({
        title: this.L('Tips'),
        content: '确认删除' + row.name + '吗？',
        okText: this.L('Yes'),
        cancelText: this.L('No'),
        onOk: async () => {

          abp.ajax.delete('/api/services/app/Delivery/Delete?id=' + row.id).then(() => {
            // this.showDeliveryPlanEditModal = false;
            this.$Notice.success({
              duration: 3,
              title: '删除成功'
            });
            this.getPage();
          }).finally(() => {
            this.saving = false;
          });
        }
      });
    },
    getStagingBuildings(projectId) {
      abp.ajax.get('/api/services/app/Project/GetStagingBuildings?projectId=' + projectId).then(res => {
        this.data1 = [];
        this.data1.push(...res.data.result);
        this.showTreeModal = true;
      }).finally(() => {
        this.saving = false;
      });
    },
    signUpStartTimeChange(date) {
      this.deliveryPlan.signUpStartTime = date;
    },
    signUpEndTimeChange(date) {
      this.deliveryPlan.signUpEndTime = date;
    }
  },
  created() {
    this.planId = parseInt(this.$route.params.planId) || 0;
    this.getCities();
  }
};
